import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { getPackageId } from 'src/routes/Checkout/store/selectors/package';
import { getIsWishlistAvailable } from 'src/store/menu/selectors';
import { getIsHotelOnly } from 'src/store/view/selectors';
import Wishlist from 'src/components/Wishlist';
import { getPath } from '../../../../store/selectors/router';
import { getHeaderTitle } from '../../../../utils/viewUtils';

const baseCls = 'checkout-header';

const Header = ({ path, isHotelOnly, isWishlistAvailable, packageId }) => {
  const title = getHeaderTitle(path, isHotelOnly);

  return title ? (
    <div className={baseCls}>
      <div className={`${baseCls}__title`}>{title}</div>
      {isWishlistAvailable && (
        <Wishlist
          type="package"
          wishlistIdentifier={packageId}
          isCheckoutPage
        />
      )}
    </div>
  ) : null;
};

Header.propTypes = {
  path: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  path: getPath(state),
  isHotelOnly: getIsHotelOnly(state),
  packageId: getPackageId(state),
  isWishlistAvailable: getIsWishlistAvailable(state),
});

export default connect(mapStateToProps)(Header);
